import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { getConf, SaveTypes } from '@configuratorware/configurator-frontendgui/App/configuration';
import { EventTypes } from '@configuratorware/configurator-frontendgui/App/Constant';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { getConfiguration } from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors";

class InteractionService extends BaseInteractionService {
  async sendReceiveOfferRequest(formData) {
    if (formData.hasError) {
      return false;
    }

    try {
      Services.ui.show('addToCartPopUpLoader');
      await Services.configurator.captureAndSaveConfiguration(SaveTypes.OFFERREQUEST);
      Services.analytics.triggerEvent(EventTypes.selected_amounts);
    } catch (e) {
      Services.ui.reportError(t('receiveOfferForm.sentError'));

      return false;
    } finally {
      Services.ui.hide('addToCartPopUpLoader');
    }

    const { savedConfiguration } = Services.configurator.state;

    const data = {
      configurationCode: savedConfiguration.code,
      emailAddress: formData.email,
      name: formData.name,
      company: formData.company,
      phoneNumber: formData.phonenumber,
      street: formData.street,
      zip: formData.zip,
      city: formData.city,
      country: formData.country,
      customerID: formData.customerID,
    };

    try {
      await Api.request({ url: 'receiveoffers/request', method: 'post', data: data });
    } catch (error) {
      Services.ui.reportError(t('receiveOfferForm.sentError'));

      return false;
    }

    return true;
  }

  async createPdfUrl(
      documentType = 'user',
      configuration = getConfiguration(Services.configurator.state),
      queryParams = {}
  ) {
    const params = { ...Api.getGETParameters(), ...queryParams };
    const customKeys = Object.keys(queryParams);
    const keys = ['_language', '_client', '_channel', '_display_net_prices', '_share_url'];
    const mergedKeys = keys.concat(customKeys);
    const query = new URLSearchParams(location.search);
    const savedConfiguration = Services.configurator.state.savedConfiguration;
    let queryString = Object.keys(params)
        .filter(key => mergedKeys.indexOf(key) !== -1)
        .map(key =>
            key === '_share_url' ? key + '=' + encodeURIComponent(params[key]) : key + '=' + params[key]
        )
        .join('&');
    if (query.has('_hide_prices')) {
      queryString = queryString.concat('&_hide_prices=' + query.get('_hide_prices'));
    }
    if (query.has('_cta_element')) {
      queryString = queryString.concat('&_cta_element=' + query.get('_cta_element'));
    }
    return `${getConf('network.baseURL', '/')}configurations/pdf/${documentType}/${
        savedConfiguration.code
    }?${queryString}`;
  }
}

export default InteractionService;
